function juraCarousel(name, autoplay, interval, centerMode, headerAbove) {
    document.querySelectorAll(name).forEach((carousel) => {
        var focusValue = centerMode ? 'center' : 0;
        console.log(centerMode);
        var standardCarousel = new Splide(carousel, {
            pagination: true,
            arrows: centerMode ? false : true,
            autoplay: autoplay,
            interval: interval,
            pauseOnHover: true,
            mediaQuery: 'min',
            gap: centerMode ? '32px' : '16px',
            focus: focusValue,
            autoWidth: true,
            type: centerMode ? 'loop' : 'slide',
            // rewind: true,
            // rewindByDrag: true,
            padding: centerMode ? { right: 'max(calc((100vw - var(--container)) / 2 + var(--container-padding)), var(--container-padding))' } : null,
            flickMaxPages: 1,
            flickPower: 400,
            arrowPath: 'M11.13,40l-2.23-2.23,17.78-17.77L8.89,2.23l2.23-2.23,19.98,20-19.98,20Z',
            breakpoints: {
                0: {
                    perPage: 1,
                    perMove: 1
                },
                641: {
                    perPage: headerAbove ? 2 : 1,
                    perMove: headerAbove ? 2 : 1,
                },
                1025: {
                    perPage: headerAbove ? 3 : 2,
                    perMove: headerAbove ? 3 : 2,
                }
            }
        });

        standardCarousel.on('ready', () => {
            standardCarousel.Components.Slides.forEach((item) => {
                if (item.slide.getAttribute('aria-hidden') === 'true') {
                    item.slide.setAttribute('tabindex', '-1');
                } else {
                    item.slide.setAttribute('tabindex', '0');
                }
            });
        });

        // TODO: only do if not centered? 
        standardCarousel.on('mounted moved resized', function () {
            var slides = standardCarousel.Components.Slides.get();
            var perPage = standardCarousel.options.perPage;
            var index = standardCarousel.index;

            slides.forEach(function (slideObj, i) {
                var slide = slideObj.slide;
                if (!centerMode) {
                    // keep only slides in the current viewport fully visible
                    if (i >= index && i < index + perPage) {
                        slide.classList.add('is-opaque');
                    } else {
                        slide.classList.remove('is-opaque');
                    }
                }
            });
        });

        standardCarousel.mount();


        standardCarousel.on('hidden', (item) => {
            item.slide.setAttribute('tabindex', -1);
        });

        standardCarousel.on('visible', (item) => {
            item.slide.setAttribute('tabindex', 0);
        });
    });

}